import Resizer from "react-image-file-resizer";

// import { b64toBlob } from './base64ToBlob';

export const resizeImage = (image: Blob): Promise<string> => {
  return new Promise((resolve) =>
    Resizer.imageFileResizer(
      image,
      1920, // Target width for 1080p
      1080, // Target height for 1080p
      "JPEG", // Format
      100, // 100% quality
      0, // No rotation
      (uri: string | Blob | ProgressEvent<FileReader>) => {
        resolve(uri as string); // Ensure it returns the base64 string
      },
      "base64"
    )
  );
};
